import VoteCreateRequestResource from "common/resources/Vote/VoteCreateRequestResource";
import { singleton } from "tsyringe";
import BaseApi from "../BaseApi";

@singleton()
export default class VoteApi extends BaseApi {
	private baseurl = `${this.apiUrl}/votes`;

	public async create(vote: VoteCreateRequestResource) {
		return this.postRequest<{}>(`${this.baseurl}`, { ...vote });
	}

	public async results(questionId: string) {
		return this.getRequest<{ choiceId: string; votes: number; percentage: number }[]>(`${this.baseurl}/results/${questionId}`);
	}
}
